"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@mui/material/styles");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const findLast_1 = __importDefault(require("lodash/findLast"));
/**
 * Hook that returns a function that returns an appropriate value based on screen width,
 * given an object of breakpoints and corresponding values.
 *
 * @example <caption>`value` will be either 1, 2, or 3 depending on screen size</caption>
 * const r = useResponsive()
 * const value = r({ xs: 1, sm: 2, md: 3 })
 * */
const useResponsive = () => {
    const theme = (0, styles_1.useTheme)();
    const matches = {
        xs: (0, useMediaQuery_1.default)(theme.breakpoints.up("xs")),
        sm: (0, useMediaQuery_1.default)(theme.breakpoints.up("sm")),
        md: (0, useMediaQuery_1.default)(theme.breakpoints.up("md")),
        lg: (0, useMediaQuery_1.default)(theme.breakpoints.up("lg")),
        xl: (0, useMediaQuery_1.default)(theme.breakpoints.up("xl")),
    };
    return (responsiveValues) => {
        const match = (0, findLast_1.default)(theme.breakpoints.keys, (breakpoint) => matches[breakpoint] && responsiveValues[breakpoint] != null);
        return match && responsiveValues[match];
    };
};
exports.default = useResponsive;
//# sourceMappingURL=useResponsive.js.map